export default __webpack_public_path__ + "static/media/react_portfolio.00327949.png";